/**
 * Represents the currently selected specification in the panel viewer.
 * Derived from linked entity query data via the spec's externalId.
 */
export interface ISelectedSpec {
    /**
     * The numeric specification ID used for API queries and routing
     */
    specificationId: number;
    /**
     * The external ID (GUID) of the specification
     */
    externalId: string;
    /**
     * The display title of the specification
     */
    title: string;
}

/**
 * Represents the currently selected plan set in the panel viewer.
 * Derived from linked entity query data via the plan set's externalId.
 */
export interface ISelectedPlanSet {
    /**
     * The external ID (GUID) of the plan set
     */
    externalId: string;
    /**
     * The display title of the specification
     */
    title: string;
    /**
     * True when the plan set has at least one page with annotations. Sourced from the
     * PlanSetEntityRecordResponse union member returned by the linked-entities batch.
     */
    hasAnnotations: boolean;
}

export enum LinkingPanelTab {
    Plans = "1",
    Specs = "2",
}
